import { media } from '@sail/engine';
import { tokens as $ } from '@sail/tokens';
import { IconConfig } from '../components/Icon';
import { css } from '../css';
export const actionButton = [
    css({
        stack: 'x',
        alignX: 'center',
        alignY: 'center',
        padding: 'small',
        borderRadius: 'action',
        transition: 'background-color 150ms ease-out',
        width: 'space.350',
        height: 'space.350',
        ':hover:not(:disabled)': {
            backgroundColor: $['color.neutral.25']
        },
        ':hover:active:not(:disabled)': {
            backgroundColor: $['color.neutral.50']
        },
        [media.down($['viewport.mobile'])]: {
            width: 'xlarge',
            height: 'xlarge'
        }
    }),
    IconConfig.customize({
        defaults: {
            size: 'xsmall'
        },
        css: {
            [media.down($['viewport.mobile'])]: {
                height: 'medium',
                width: 'medium'
            }
        }
    })
];

//# sourceMappingURL=ActionButton.js.map